<div>
  <strong class="art-agt-title">{{ title }}</strong>
  <ng-content></ng-content>
</div>
